import { STUDENT_COMPETENCY_STATUS } from '../resources/studentCompetencyStatus';

export const getStudentCompetencyStatusColor = (status) => {
  switch (status) {
    case STUDENT_COMPETENCY_STATUS.NOT_STARTED:
      return 'inverse';
    case STUDENT_COMPETENCY_STATUS.STARTED:
      return 'primary';
    case STUDENT_COMPETENCY_STATUS.TO_BE_APPROVED:
      return 'info';
    case STUDENT_COMPETENCY_STATUS.NOT_APPROVED:
      return 'warning';
    case STUDENT_COMPETENCY_STATUS.RETURNED:
      return 'secondary';
    case STUDENT_COMPETENCY_STATUS.TO_BE_SIGNED:
      return 'tertiary';
    case STUDENT_COMPETENCY_STATUS.ACQUIRED:
      return 'success';
    case STUDENT_COMPETENCY_STATUS.SENT_OUT:
      return 'tertiary';
    case STUDENT_COMPETENCY_STATUS.SENDING_ERROR:
      return 'error';
    default:
      return 'inverse';
  }
};